function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 144v288c0 26 22 48 48 48h48V96H48c-26 0-48 22-48 48zM336 0H176c-26 0-48 22-48 48v432h256V48c0-26-22-48-48-48zm0 96H176V48h160v48zm128 0h-48v384h48c26 0 48-22 48-48V144c0-26-22-48-48-48z"
});

function SvgSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _ref);
}

export default SvgSuitcase;